<template>
  <div class="post-preview-container" v-if="posts.length">
    <template v-for="(post) in posts">
      <div
        class="post-preview"
        @click="showFullInfo($event, post)"
      >
        <div :class="`tonal-indicator  ${getTonalClass(post.trust)}`"></div>
        <post-preview-header :post="post" :date-post="moment(post.created_date).format('HH:mm DD.MM.YYYY')" />
        <post-preview-body :post="post"></post-preview-body>
        <post-counters :post="post"/>
      </div>
    </template>
  </div>
</template>

<script>
  import PostPreviewHeader from './postPreviewHeader.vue';
  import PostPreviewBody from './postPreviewBody.vue';
  import PostCounters from '../../postCounters.vue';
  import Post from '../../post.vue';
  import PostFull from '../../PostFull.vue';
  import moment from 'moment';

  export default {
    name: 'postPreview',
    components: { Post, PostPreviewBody, PostPreviewHeader, PostCounters, PostFull },
    props: {
      posts: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        moment,
      };
    },
    methods: {
      getTonalClass({ trust }) {
        if (trust === null || trust === 0) {
          return 'tonal-indicator__netural';
        }

        if (trust > 0) {
          return 'tonal-indicator__positive';
        }

        return 'tonal-indicator__negative';
      },
      showFullInfo(event, post) {
        const target = event.target;
        this.$root.$emit('togglePostToModal', {target, post});
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .post-preview-container {
    display:flex;
    flex-wrap:wrap;
  }

  .post-preview  {
    display flex
    flex-direction column
    position: relative;
    width:32%;
    height auto
    cursor: pointer;
    padding: 15px;
    margin-bottom: 20px;
    margin-right 20px;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    transition-property: box-shadow;
    transition-duration: .5s;
  }

  .post-preview:hover {
    box-shadow: 0 5px 10px rgba(0,0,0,0.20);
  }

  .post-preview .post-preview-body {max-height: 100px;}


  .post-preview:nth-child(3n) {
    margin-right: 0;
  }

  .post-more-container
    background-color #f5f5f5
    padding 15px
    margin-bottom 20px
    border-top 5px solid #0085ff
    box-sizing border-box
  .post-preview-row
    display flex
    align-items flex-start
    justify-content flex-start
    width 100%
    flex-wrap wrap
  .post__date
    width 100%
    text-align right
    margin-top auto
    display flex
    align-items center
    justify-content flex-end
  .post__source-icon
    margin-right .5em
  .post-preview__active
    position relative
  .post-preview__active:after {
    position absolute
    bottom -22px
    left -1px
    display block
    height 22px
    width 100%
    background-color #0085ff
    border: 1px solid #0085ff
    content ''
  }
  .tonal-indicator
    position absolute
    overflow hidden
    top: 0
    right 0
    width 40px
    height 40px
  .tonal-indicator__netural::before
    display block
    position absolute
    top -20px
    right -20px
    width: 40px
    height: 40px
    background-color  #d8e1e9
    transform rotate(-45deg)
    content ''
  .tonal-indicator__positive::before
    display block
    position absolute
    top -20px
    right -20px
    width: 40px
    height: 40px
    background-color #03bb9a
    transform rotate(-45deg)
    content ''
  .tonal-indicator__negative::after
    display block
    position absolute
    top -20px
    right -20px
    width: 40px
    height: 40px
    background-color #ed002b
    transform rotate(-45deg)
    content ''

  @media (max-width: 1365px) {

    .post-preview-container {
      justify-content space-between
    }

    .post-preview {
      width: 360px;
      margin-right: 0;
    }

    .post-preview:nth-child(3n) {
      margin-right: 0;
    }

    .post-preview:nth-child(2n) {
      margin-right: 0;
    }
  }

  @media (max-width: 1040px) {

    .post-preview-container {
      justify-content space-between
    }

    .post-preview {
      width: 360px;
      margin-right: 0;
    }

    .post-preview:nth-child(3n) {
      margin-right: 0;
    }

    .post-preview:nth-child(2n) {
      margin-right: 0;
    }
  }


  @media (max-width: 760px) {
    .post-preview-container {
      align-items center
    }

    .post-preview {
      width: 100%;
      margin-right: 0;
    }

    .post-preview:nth-child(3n) {
      margin-right: 0;
    }

    .post-preview:nth-child(2n) {
      margin-right: 0;
    }
  }


</style>
